import React from "react";
import PopoverBtn from "../../popoverBtn";
import { Col, Row } from "react-bootstrap";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import FloatingLabel from "react-bootstrap/FloatingLabel";
import styled from "styled-components";

function DateInput({
                     children,
                     popoverText,
                     value,
                     placeholder,
                     onChange,
                     fullWidth,
                     className,
                     ...params
                   }) {
  const fieldValue = value ? new Date(value) : null;

  const setDate = (date) => {
    const dateString = new Date(date);
    const year = dateString.getFullYear();
    const month = (dateString.getMonth() + 1).toString().padStart(2, "0");
    const day = dateString.getDate().toString().padStart(2, "0");
    const formattedDate = `${year}-${month}-${day}`;
    onChange(date ? formattedDate : "");
  };
  const PcrPage = location.href.includes("/pcr");

  return (
    <Row className={`align-items-center flex-nowrap position-relative ${PcrPage ? "mb-3" : ""}`}>
      <Col xs={12} md={fullWidth || popoverText === null ? 12 : 11}>
        <CustomFloatingLabel
          label={params?.label}
          className={`pt-2 color-info ${className ? className : ""}`}
        >
          <CustomDate
            {...params}
            selected={fieldValue}
            onChange={setDate}
            placeholderText={placeholder}
            className={`form-control pe-5 pe-md-2 ${className ? className : ""}`}
          />
        </CustomFloatingLabel>
        {children}
      </Col>
      {popoverText !== null && (
        <div className="position-absolute top-50 translate-middle-y end-0 w-auto me-3 mt-2">
          <PopoverBtn text={popoverText} />
        </div>
      )}
    </Row>
  );
}

export default DateInput;

const CustomDate = styled(DatePicker)`
    padding-top: 30px !important;
`;

export const CustomFloatingLabel = styled(FloatingLabel)`
    label {
        opacity: 0.65;
        font-size: 13px;
        margin-top: 2px;
    }
`;
